<div class="d-flex justify-content-between align-items-center mb-5">
  <h2 class="fw-bold f-size-24 my-auctions__title mb-0">ჩემი აუქციონი</h2>
  <div class="dropdown d-md-none d-block">
    <button
      id="filterDropdownMobile"
      class="btn btn-light my-auctions__filter-button"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      ფილტრი
    </button>
    <form
      [formGroup]="filterForm"
      class="dropdown-menu"
      aria-labelledby="filterDropdownWeb"
    >
      <span
        class="dropdown-item py-3 my-auctions__arrow d-flex justify-content-between align-items-center cursor-pointer user-select-none border-bottom"
        [ngClass]="{ 'my-auctions__arrow__active': getIsStatusOpen }"
        (click)="openCloseStatuses()"
        >სტატუსი</span
      >
      <span
        class="dropdown-item px-4 py-3 my-auctions__arrow d-flex justify-content-between align-items-center cursor-pointer user-select-none border-bottom"
        [ngClass]="{ 'my-auctions__arrow__active': getIsDateFilterOpen }"
        (click)="openCloseDatesFilter()"
      >
        თარიღი
      </span>
      <div
        [hidden]="!getIsStatusOpen"
        class="dropdown-item bg-light-shade-blue border-bottom"
      >
        <div
          *ngFor="let status of getAuctionStatuses"
          class="my-auctions__filter-status-item py-2"
          unselectable="on"
        >
          <label
            class="mb-0 f-color-actions-text d-flex align-items-center justify-content-between cursor-pointer user-select-none"
            >{{ status.display_name }}
            <app-checkbox
              [checked]="filterForm.get('status').value.includes(status.key)"
              [control]="filterForm.get('status')"
              [elementValue]="status.key"
            ></app-checkbox>
          </label>
        </div>
      </div>
      <div
        [hidden]="!getIsDateFilterOpen"
        class="dropdown-item bg-light-shade-blue border-bottom py-3"
      >
        <div
          class="d-flex align-items-center justify-content-between flex-wrap bg-light-shade-blue flex-column"
        >
          <div class="form-group dropdown-menu__date">
            <label>დაწყების თარიღი</label>
            <input
              appFormErrorMsg
              class="form-control auction-custom-input"
              formControlName="active_from"
              name="active_from"
              type="date"
            />
          </div>
          <!-- <div class="form-group dropdown-menu__date">
            დაწყების თარიღი
            <input [owlDateTime]="active_from" [owlDateTimeTrigger]="active_from" placeholder="მიუთითეთ თარიღი" appFormErrorMsg class="form-control auction-custom-input mt-2" formControlName="active_from"
            name="active_from">
            <owl-date-time #active_from></owl-date-time>
          </div> -->
          <div class="form-group dropdown-menu__date">
            <label>დასრულების თარიღი</label>
            <input
              appFormErrorMsg
              class="form-control auction-custom-input"
              formControlName="active_to"
              name="active_to"
              type="date"
            />
          </div>
          <!-- <div class="form-group dropdown-menu__date">
            დასრულების თარიღი
            <input [owlDateTime]="active_to" [owlDateTimeTrigger]="active_to" placeholder="მიუთითეთ თარიღი" appFormErrorMsg class="form-control auction-custom-input mt-2" formControlName="active_to"
            name="active_to">
            <owl-date-time #active_to></owl-date-time>
          </div> -->
        </div>
      </div>
      <div
        class="dropdown-item d-flex justify-content-end align-items-center py-3"
      >
        <button
          class="btn btn-link fw-medium f-color-vibrant-blue mr-2"
          (click)="clearFilter()"
        >
          <u>გასუფთავება</u>
        </button>
        <button
          class="btn btn-primary bg-vibrant-blue fw-medium"
          (click)="saveFilter()"
        >
          შენახვა
        </button>
      </div>
    </form>
    <!-- <div class="dropdown-menu" aria-labelledby="filterDropdownMobile">
      <a class="dropdown-item" href="#">Action 1</a>
      <a class="dropdown-item" href="#">Action 2</a>
    </div> -->
  </div>
</div>
<div class="my-auctions">
  <div
    class="d-flex justify-content-between align-items-center mb-sm-3 mb-0 flex-wrap"
  >
    <!-- <div class="my-auctions__tabs d-flex flex-md-row flex-column mb-md-0 mb-3">
      <div *ngFor="let tab of formatedTabs" class="bg-tabs-grey cursor-pointer py-2 px-3"
        [ngClass]="{ 'bg-vibrant-blue f-color-white': tab.id === currentTab }"
        (click)="tab.id !== currentTab ? getChildData(tab.id) : ''">
        {{ tab.title }}</div>
    </div> -->
    <div
      *ngIf="parentTabs.length !== 1"
      class="d-flex justify-content-between align-items-center flex-wrap"
    >
      <div class="my-auctions__tabs d-flex mb-sm-0 mb-3">
        <div
          *ngFor="let tab of parentTabs"
          class="bg-tabs-grey border cursor-pointer py-2 px-3 f-size-14"
          [ngClass]="{
            'bg-vibrant-blue f-color-white': tab.id === getCurrentParentTab
          }"
          (click)="tab.id !== getCurrentParentTab ? changeParrent(tab.id) : ''"
        >
          {{ tab.title }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div
        class="my-auctions__filter ng-select-placeholder-color mr-0 mr-md-3 mb-sm-0 mb-3"
      >
        <button
          *ngIf="userCanManageAuctions"
          class="btn btn-primary my-auctions__filter-button"
          (click)="resultsExport()"
          [ngClass]="{ disabled: !myAuctionsList.length }"
        >
          შედეგების ექსპორტი
        </button>

        <!-- <ng-select [hidden]="currentTab !== 1" [items]="getAuctionStatuses" [clearable]="true" bindLabel="name"
          bindValue="key" placeholder="ყველა აუქციონი" class="mb-3 ng-select-bg-light-shade-blue" [searchable]="false"
          [(ngModel)]="statusValue" (change)="filterStatusChanges()">
          <ng-template ng-option-tmp let-item="item">
            <span class="f-size-14">
              {{ item.display_name }}
            </span>
          </ng-template>
          <ng-template label="real_estate_type_group_id" ng-label-tmp let-item="item">
            <span class="f-size-14">
              {{ item.display_name }}
            </span>
          </ng-template>
        </ng-select> -->
      </div>
      <!-- basic dropdown template -->
      <div class="dropdown d-md-block d-none">
        <button
          id="filterDropdownWeb"
          class="btn btn-primary my-auctions__filter-button"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          ფილტრი
        </button>
        <form
          [formGroup]="filterForm"
          class="dropdown-menu"
          aria-labelledby="filterDropdownWeb"
        >
          <span
            class="dropdown-item px-4 py-3 my-auctions__arrow d-flex justify-content-between align-items-center cursor-pointer user-select-none border-bottom"
            [ngClass]="{ 'my-auctions__arrow__active': getIsStatusOpen }"
            (click)="openCloseStatuses()"
            >სტატუსი</span
          >

          <span
            class="dropdown-item px-4 py-3 my-auctions__arrow d-flex justify-content-between align-items-center cursor-pointer user-select-none border-bottom"
            [ngClass]="{ 'my-auctions__arrow__active': getIsDateFilterOpen }"
            (click)="openCloseDatesFilter()"
          >
            თარიღი
          </span>
          <div
            [hidden]="!getIsStatusOpen"
            class="dropdown-item bg-light-shade-blue border-bottom"
          >
            <div
              *ngFor="let status of getAuctionStatuses"
              class="my-auctions__filter-status-item py-2"
              unselectable="on"
            >
              <label
                class="mb-0 f-color-actions-text d-flex align-items-center justify-content-between cursor-pointer user-select-none"
                >{{ status.display_name }}
                <app-checkbox
                  [checked]="
                    filterForm.get('status').value.includes(status.key)
                  "
                  [control]="filterForm.get('status')"
                  [elementValue]="status.key"
                ></app-checkbox>
              </label>
            </div>
          </div>
          <div [hidden]="!getIsDateFilterOpen">
            <div
              class="d-flex align-items-center justify-content-between flex-wrap bg-light-shade-blue px-4 py-3 flex-column"
            >
              <div class="form-group w-100">
                <label>დაწყების თარიღი</label>
                <input
                  appFormErrorMsg
                  class="form-control auction-custom-input"
                  formControlName="active_from"
                  name="active_from"
                  type="date"
                />
              </div>
              <div class="form-group w-100">
                <label>დასრულების თარიღი</label>
                <input
                  appFormErrorMsg
                  class="form-control auction-custom-input"
                  formControlName="active_to"
                  name="active_to"
                  type="date"
                />
              </div>
              <!-- <div class="form-group w-100">
                დაწყების თარიღი
                <input [owlDateTime]="activee_from" [owlDateTimeTrigger]="activee_from" placeholder="მიუთითეთ თარიღი" appFormErrorMsg class="form-control auction-custom-input mt-2" formControlName="active_from"
                name="active_from">
                <owl-date-time [pickerType]="'calendar'" #activee_from></owl-date-time>
              </div>
              <div class="form-group w-100">
                დასრულების თარიღი
                <input [owlDateTime]="activee_to" [owlDateTimeTrigger]="activee_to" placeholder="მიუთითეთ თარიღი" appFormErrorMsg class="form-control auction-custom-input mt-2" formControlName="active_to"
                name="active_to">
                <owl-date-time [pickerType]="'calendar'" #activee_to></owl-date-time>
              </div> -->
            </div>
          </div>
          <div class="px-4 d-flex justify-content-end align-items-center py-3">
            <button
              class="btn btn-link fw-medium f-color-vibrant-blue mr-2"
              (click)="clearFilter()"
            >
              <u>გასუფთავება</u>
            </button>
            <button
              class="btn btn-primary bg-vibrant-blue fw-medium"
              (click)="saveFilter()"
            >
              შენახვა
            </button>
          </div>
        </form>
      </div>
      <!-- basic dropdown template -->
    </div>
  </div>

  <div
    *ngIf="myAuctionsList && !myAuctionsList.length"
    class="w-100 text-center"
  >
    <h1>აუქციონები არ მოიძებნა</h1>
  </div>

  <div
    *ngIf="myAuctionsList && myAuctionsList.length"
    class="d-flex flex-column"
  >
    <div *ngFor="let item of myAuctionsList" class="my-auctions__card-margin">
      <div class="card">
        <div
          class="my-auctions__card card-body d-flex flex-column flex-lg-row flex-md-row align-items-center justify-content-between f-size-14"
        >
          <div class="col col-md-2 px-0 mb-md-0 mb-3 position-relative">
            <a [routerLink]="'/auction/' + item.uuid">
              <picture>
                <source
                  type="image/webp"
                  [srcset]="
                    item.image
                      ? item.image.url + '_thumbnail.webp'
                      : '/assets/images/no-img/no-image_thumb.webp'
                  "
                />
                <source
                  type="image/jpg"
                  [srcset]="
                    item.image
                      ? item.image.url + '_thumbnail.jpg'
                      : '/assets/images/no-img/no-image_thumb.jpg'
                  "
                />
                <source
                  type="image/webp"
                  [srcset]="
                    item.image
                      ? item.image.url + '.webp'
                      : '/assets/images/no-img/no-image_thumb.webp'
                  "
                />
                <source
                  type="image/jpg"
                  [srcset]="
                    item.image
                      ? item.image.url + '.jpg'
                      : '/assets/images/no-img/no-image_thumb.jpg'
                  "
                />
                <img
                  [src]="item.image ? item.image.url + '.jpg' : ''"
                  alt="img"
                  class="my-auctions__card__img"
                />
              </picture>
            </a>
            <!-- <p class="mb-2 my-auctions__card__statuses d-flex d-lg-none" [ngClass]="{
              'my-auctions__card__statuses__current': item.status_key === 'active',
              'my-auctions__card__statuses__sold': (item.status_key === 'finished' || item.status_key === 'manually_finished'),
              'my-auctions__card__statuses__not-sold': item.status_key === 'failed',
              'my-auctions__card__statuses__ruined': item.status_key === 'stopped',
              'my-auctions__card__statuses__stopped': item.status_key === 'manually_failed',
              'my-auctions__card__statuses__not-started': item.status_key === 'not_started',
              'my-auctions__card__statuses__unpublished': item.status_key === 'unpublished'
            }">
              {{ item.status }}
            </p> -->
            <div
              *ngIf="getCurrentParentTab === 'manageable'"
              class="my-auctions__card__actions d-flex flex-column align-items-md-end d-md-none"
            >
              <button
                #buttonRef
                [ngClass]="{
                  'my-auctions__card__actions__button__z-index':
                    getActionsModalComponent.includes(item.uuid)
                }"
                class="btn btn-link my-auctions__card__actions__button bg-white"
                data-toggle="tooltip"
                data-placement="top"
                title="ქმედებები"
                (click)="actionsModal(item.uuid)"
              >
                <span #buttonRef></span>
                <span #buttonRef></span>
                <span #buttonRef></span>
              </button>
              <div
                *ngIf="getActionsModalComponent.includes(item.uuid)"
                class="d-flex flex-column align-items-end"
              >
                <div class="my-auctions__card__actions__bg"></div>
                <div
                  class="my-auctions__card__actions__modal position-absolute bg-white d-flex flex-column"
                >
                  <div
                    *ngFor="let action of getActions"
                    class="cursor-pointer"
                    #modalRef
                  >
                    <button
                      *ngIf="isActionHidden(action.id, item)"
                      #modalRef
                      [disabled]="isActionDisabled(action.id, item)"
                      class="btn btn-link f-size-14 f-color-actions-text w-100 text-left"
                      (click)="makeAction(action.id, item.uuid, action.name)"
                    >
                      {{ action.name }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col col-md-3 px-0 mb-md-0 mb-3 f-size-14">
            <p class="mb-2">{{ item.title }}</p>
            <p class="mb-0 f-color-actions-text">
              {{ item.city ? item.city + "," : "" }} {{ item.street }}
            </p>
          </div>
          <div class="col col-md-3 px-0 mb-md-0 mb-3 f-size-14">
            <p class="mb-2">აუქციონის #: {{ item.auction_number }}</p>
            <p class="mb-2">ლოტის #: {{ item.lot_number }}</p>
            <p class="mb-0 f-color-actions-text">
              {{ formatDate(item.start_date) }} -
              {{ formatDate(item.end_date) }}
            </p>
          </div>

          <div class="col px-0 d-md-none d-flex mb-3">
            <div class="col col-md-1 px-0 mb-md-0 mb-2 f-size-14">
              <p class="mb-2">{{ item.last_bid?.type === endedAuctionTypes.endedAuctionBuyNowType? 'Buy Now' : item.bids_count }}</p>
              <p class="mb-0">ბიდი</p>
            </div>
            <div class="col col-md-2 px-0 mb-md-0 mb-2">
              <p
                class="mb-2 my-auctions__card__statuses d-flex f-color-actions-text"
                [ngClass]="{
                  'my-auctions__card__statuses__current':
                    item.status_key === 'active',
                  'my-auctions__card__statuses__sold':
                    item.status_key === 'finished' ||
                    item.status_key === 'manually_finished',
                  'my-auctions__card__statuses__not-sold':
                    item.status_key === 'failed',
                  'my-auctions__card__statuses__ruined':
                    item.status_key === 'stopped',
                  'my-auctions__card__statuses__stopped':
                    item.status_key === 'manually_failed',
                  'my-auctions__card__statuses__not-started':
                    item.status_key === 'not_started',
                  'my-auctions__card__statuses__unpublished':
                    item.status_key === 'unpublished'
                }"
              >
                {{ item.status }}
              </p>
              <button
                *ngIf="
                  getCurrentParentTab === 'manageable' ||
                  checkParticipatedWonAuctions(item)
                "
                class="mb-0 btn btn-link f-color-dark f-size-14 p-0 text-left"
                (click)="openResultsModal(item.uuid)"
              >
                <u>{{
                  getCurrentParentTab === "manageable"
                    ? "შედეგების ნახვა"
                    : "მოგებული აუქციონი"
                }}</u>
              </button>
            </div>
          </div>

          <div
            class="col col-md-1 px-0 mb-md-0 mb-2 f-size-14 d-md-block d-none"
          >
            <p class="mb-2">ბიდი</p>
            <p class="mb-0">{{ item.last_bid?.type === endedAuctionTypes.endedAuctionBuyNowType? 'Buy Now' : item.bids_count}}</p>
          </div>
          <div class="col col-md-2 px-0 mb-md-0 mb-2 d-md-block d-none">
            <p
              class="mb-2 my-auctions__card__statuses d-flex"
              [ngClass]="{
                'my-auctions__card__statuses__current':
                  item.status_key === 'active',
                'my-auctions__card__statuses__sold':
                  item.status_key === 'finished' ||
                  item.status_key === 'manually_finished',
                'my-auctions__card__statuses__not-sold':
                  item.status_key === 'failed',
                'my-auctions__card__statuses__ruined':
                  item.status_key === 'stopped',
                'my-auctions__card__statuses__stopped':
                  item.status_key === 'manually_failed',
                'my-auctions__card__statuses__not-started':
                  item.status_key === 'not_started',
                'my-auctions__card__statuses__unpublished':
                  item.status_key === 'unpublished'
              }"
            >
              {{ item.status }}
            </p>
            <button
              *ngIf="
                getCurrentParentTab === 'manageable' ||
                checkParticipatedWonAuctions(item)
              "
              class="mb-0 btn btn-link f-color-dark f-size-14 p-0 text-left"
              (click)="openResultsModal(item.uuid)"
            >
              <u>{{
                getCurrentParentTab === "manageable"
                  ? "შედეგების ნახვა"
                  : "მოგებული აუქციონი"
              }}</u>
            </button>
          </div>

          <div
            *ngIf="getCurrentParentTab === 'manageable'"
            class="my-auctions__card__actions d-md-flex d-none flex-column align-items-md-end align-items-center"
          >
            <button
              #buttonRef
              class="btn btn-link my-auctions__card__actions__button"
              data-toggle="tooltip"
              data-placement="top"
              title="ქმედებები"
              (click)="actionsModal(item.uuid)"
            >
              <span #buttonRef></span>
              <span #buttonRef></span>
              <span #buttonRef></span>
            </button>
            <div *ngIf="getActionsModalComponent.includes(item.uuid)">
              <div class="testtt"></div>
              <div
                class="my-auctions__card__actions__modal position-absolute bg-white d-flex flex-column"
              >
                <div
                  *ngFor="let action of getActions"
                  class="cursor-pointer"
                  #modalRef
                >
                  <button
                    *ngIf="isActionHidden(action.id, item)"
                    #modalRef
                    [disabled]="isActionDisabled(action.id, item)"
                    class="btn btn-link f-size-14 f-color-actions-text w-100 text-left"
                    (click)="makeAction(action.id, item.uuid, action.name)"
                  >
                    {{ action.name }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="total > 15"
      class="my-auctions__custom-pagination col-12 d-flex justify-content-center mb-2"
    >
      <span
        class="my-auctions__custom-pagination__left-arrow mr-3 my-auctions__custom-pagination__circle border rounded-circle d-flex justify-content-center align-items-center"
        (click)="decreaseCurrentPage()"
      >
        <img src="../../../../assets/images/right-arrow.svg" alt="arrow" />
      </span>
      <div *ngFor="let item of totalPages">
        <div
          *ngIf="
            item === currentPage - 1 ||
            item === currentPage ||
            item === currentPage + 1
          "
          [ngClass]="{
            'my-auctions__custom-pagination__active f-color-white':
              currentPage === item
          }"
          class="my-auctions__custom-pagination__circle rounded-circle d-flex justify-content-center align-items-center f-color-dark mx-2"
          (click)="fPagination(item)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <span
        class="ml-3 my-auctions__custom-pagination__circle d-flex justify-content-center align-items-center border rounded-circle"
        (click)="increaseCurrentPage()"
      >
        <img src="../../../../assets/images/right-arrow.svg" alt="arrow" />
      </span>
    </div>
  </div>
</div>

<!-- delete Modal -->
<div *ngIf="actionConfirmationModalState" class="custom-modal">
  <button
    class="custom-modal__bg"
    (click)="actionConfirmationModal(false)"
  ></button>
  <div class="custom-modal__component">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            აუქციონის {{ actionConfirmationModalData.title }}
          </h5>
          <button
            type="button"
            class="close"
            (click)="actionConfirmationModal(false)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p *ngIf="!actionConfirmationModalLoader" class="mb-0">
            ნამდვილად გსურთ აუქციონის {{ actionConfirmationModalData.title }}?
          </p>
          <p *ngIf="actionConfirmationModalLoader" class="mb-0">
            გთხოვთ დაელოდოთ
          </p>
        </div>
        <div class="modal-footer">
          <button
            *ngIf="!actionConfirmationModalLoader"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            (click)="actionConfirmationModal(false)"
          >
            გაუქმება
          </button>
          <button
            *ngIf="!actionConfirmationModalLoader"
            type="button"
            class="btn btn-primary"
            (click)="
              actionConfirmationModal(
                true,
                actionConfirmationModalData.actionId
              )
            "
          >
            {{ actionConfirmationModalData.title }}
          </button>
          <app-loader *ngIf="actionConfirmationModalLoader"></app-loader>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /delete Modal -->

<!-- Form Modal -->
<div *ngIf="isFormModalOpen" class="custom-modal">
  <button class="custom-modal__bg" (click)="closeFormModal()"></button>
  <div class="custom-modal__component">
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h5 class="modal-title">აუქციონის შეწყვეტა</h5>
          <button type="button" class="close" (click)="closeFormModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div> -->
        <div class="modal-header align-items-center p-4">
          <h5 class="modal-title f-color-dark f-size-14">აუქციონის შეწყვეტა</h5>
          <button type="button" class="close" (click)="closeFormModal()">
            <img src="/assets/images/close.svg" alt="X" />
          </button>
        </div>
        <div class="modal-body p-4">
          <h4 class="f-size-17 fw-bold mb-3">
            მიუთითეთ აუქციონის შეწყვტის მიზეზი
          </h4>
          <form [formGroup]="form" class="mb-3">
            <textarea
              appFormErrorMsg
              formControlName="reason"
              class="form-control w-100"
              rows="4"
              type="text"
              placeholder="მიუთითეთ კომენტარი (სავალდებულოა)"
              [readonly]="auctionStopModalLoader"
            ></textarea>
            <label
              class="modal-body--upload-file f-color-vibrant-blue f-size-14 fw-bold cursor-pointer mt-3"
            >
              ატვირტთე ფაილი
              <input
                ref="uploader"
                multiple
                (change)="uploadFiles($event)"
                class="d-none"
                type="file"
                [disabled]="auctionStopModalLoader"
              />
            </label>
            <div
              *ngFor="let file of form.get('files').value; let i = index"
              class="modal-body--uploaded-files d-flex justify-content-between align-items-center"
            >
              <span class="f-color-black f-size-14">{{ file.name }}</span>
              <button
                [disabled]="auctionStopModalLoader"
                type="button"
                class="close"
                (click)="removeFile(i)"
              >
                <img src="/assets/images/close.svg" alt="X" />
              </button>
            </div>
          </form>

          <div class="d-flex justify-content-end align-items-center">
            <button
              *ngIf="!auctionStopModalLoader"
              type="button"
              class="fw-medium py-3 px-4 mr-3 btn btn-light"
              data-dismiss="modal"
              (click)="closeFormModal()"
            >
              გაუქმება
            </button>
            <button
              *ngIf="!auctionStopModalLoader"
              type="button"
              class="fw-medium py-3 px-4 btn btn-primary bg-vibrant-blue"
              (click)="auctionStop(isFormModalOpen)"
            >
              შეწყვეტა
            </button>
            <app-loader *ngIf="auctionStopModalLoader"></app-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /Form Modal -->

<!-- Results modal -->
<div *ngIf="isResultsModalOpen" class="custom-modal">
  <button class="custom-modal__bg" (click)="closeResultsModal()"></button>
  <div class="custom-modal__component">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">შედეგები</h5>
        <button type="button" class="close" (click)="closeResultsModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="print-manageable-section">
        <div class="d-flex justify-content-between align-items-center">
          <p>აუქციონის ნომერი</p>
          <p class="fw-Bold">{{ auctionResultsData.auction_number }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>ლოტის ნომერი</p>
          <p class="fw-Bold">{{ auctionResultsData.lot_number }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>საქმის ნომერი</p>
          <p class="fw-Bold">{{ auctionResultsData.case_number }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>დასახელება</p>
          <p class="fw-Bold">{{ auctionResultsData.title }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>საწყისი ფასი</p>
          <p class="fw-Bold">
            {{ auctionResultsData.starting_price | priceFormatter }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>საგარანტიო ღირებულება</p>
          <p class="fw-Bold">
            {{ auctionResultsData.warranty_price | priceFormatter }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>გასაყიდი ფასი</p>
          <p class="fw-Bold">
            {{
              getServerTime > auctionResultsData.end_date_timestamp &&
              (auctionResultsData.status_key === "finished" ||
                auctionResultsData.status_key === "manually_finished")
                ? (auctionResultsData.current_price | priceFormatter)
                : "-"
            }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>ბიჯების რაოდენობა</p>
          <p class="fw-Bold">{{ auctionResultsData.bids_count }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-start">
          <p>აუქციონის ჩატარების პერიოდი</p>
          <p class="fw-Bold">
            {{ formatDate(auctionResultsData.start_date, true) }} <br />
            {{ formatDate(auctionResultsData.end_date, true) }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-start">
          <p>გადახდის ბოლო ვადა</p>
          <p class="fw-Bold">
            {{
              formatDate(
                auctionResultsData.end_date,
                false,
                auctionResultsData.payment_period
              )
            }}
            <br />
          </p>
        </div>

        <div class="d-flex justify-content-between align-items-center">
          <p>გამარჯვებულის სახელი</p>
          <p
            *ngIf="!checkParticipatedWonAuctions(auctionResultsData)"
            class="fw-Bold"
          >
            {{
              auctionResultsData.last_bid &&
              auctionResultsData.last_bid.user_name
                ? auctionResultsData.last_bid.user_name
                : "-"
            }}
            {{
              auctionResultsData.last_bid &&
              auctionResultsData.last_bid.user_identifier_number
                ? "(" + auctionResultsData.last_bid.user_identifier_number + ")"
                : ""
            }}
          </p>
          <p
            *ngIf="checkParticipatedWonAuctions(auctionResultsData)"
            class="fw-Bold"
          >
            {{
              getUserInformation.first_name + " " + getUserInformation.last_name
            }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>გამარჯვებულის ტელეფონის ნომერი</p>
          <p
            *ngIf="!checkParticipatedWonAuctions(auctionResultsData)"
            class="fw-Bold"
          >
            {{
              auctionResultsData.last_bid &&
              auctionResultsData.last_bid.user_phone_number
                ? auctionResultsData.last_bid.user_phone_number
                : "-"
            }}
          </p>
          <p
            *ngIf="checkParticipatedWonAuctions(auctionResultsData)"
            class="fw-Bold"
          >
            {{ getUserInformation.phone_number }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>გამარჯვებულის ელ.ფოსტა</p>
          <p
            *ngIf="!checkParticipatedWonAuctions(auctionResultsData)"
            class="fw-Bold"
          >
            {{
              auctionResultsData.last_bid &&
              auctionResultsData.last_bid.user_email
                ? auctionResultsData.last_bid.user_email
                : "-"
            }}
          </p>
          <p
            *ngIf="checkParticipatedWonAuctions(auctionResultsData)"
            class="fw-Bold"
          >
            {{ getUserInformation.email }}
          </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>სტატუსი</p>
          <p class="fw-Bold">{{ auctionResultsData.status }}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <p>მისამართი</p>
          <p class="fw-Bold">
            {{
              auctionResultsData.street ? auctionResultsData.street + "," : ""
            }}
            {{ auctionResultsData.city ? auctionResultsData.city + "," : "" }}
            {{ auctionResultsData.country ? auctionResultsData.country : "" }}
          </p>
        </div>
      </div>
      <div
        class="modal-footer justify-content-start"
        *ngIf="getCurrentParentTab === 'manageable' || invoiceButtonState"
      >
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-dismiss="modal"
          (click)="
            getCurrentParentTab === 'manageable'
              ? print('manageable')
              : print('participated')
          "
        >
          {{
            getCurrentParentTab === "manageable"
              ? "შედეგების ბეჭდვა"
              : "ინვოისის ბეჭდვა"
          }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Print participated auctions -->

<div class="print" id="print-participated-section" [hidden]="true">
  <img src="../assets/images/logo.svg" alt="" />
  <div class="print-content align-items-center" *ngIf="auctionResultsData">
    <div class="print-top">
      <p>
        <b>დასახელება : </b
        ><span *ngIf="checkParticipatedWonAuctions(auctionResultsData)">{{
          getUserInformation.legal_title
            ? getUserInformation.legal_title
            : getUserInformation.first_name + " " + getUserInformation.last_name
        }}</span>
      </p>
      <p>
        <b>{{ getUserInformation.id_number ? "ს/კ" : "პ/ნ" }} :</b>
        {{
          getUserInformation.id_number
            ? getUserInformation.id_number
            : getUserInformation.personal_number
        }}
      </p>
      <p><b>თარიღი :</b> {{ currentDate }}</p>
    </div>
    <div class="print-body mt-2">
      <table class="w-100">
        <thead>
          <tr>
            <th>დანიშნულება</th>
            <th>ღირებულება</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>მოგებული აუქციონის საზღაური</p>
              <p>აუქციონის ნომერი: {{ auctionResultsData.auction_number }}</p>
              <p>ლოტის ნომერი: {{ auctionResultsData.lot_number }}</p>
            </td>
            <td>
              {{ finalPrice }}
            </td>
          </tr>
          <tr>
            <td>
              ჯამი
              .............................................................................................................................
            </td>
            <td>{{ finalPrice }} ლარი</td>
          </tr>
          <tr>
            <td class="border-right-none">
              გადახდის ბოლო თარიღი : {{ paymentExpirationDate }}
            </td>
            <td class="border-left-none"></td>
          </tr>
        </tbody>
      </table>
      <div class="info mt-3">
        <p>მიმღები: <span class="info-label">შპს თინეთი</span></p>
        <p>ს/კ: <span class="info-label">402116474</span></p>
        <p>სს “თიბისი ბანკი”</p>
        <p>მიმღები ბანკის კოდი: <span class="info-label">TBCBGE22</span></p>
        <p>
          მიმღების ანგარიშის №:
          <span class="info-label">GE55TB7165736020100005</span>
        </p>
      </div>
    </div>
  </div>
  <div class="print-footer">
    <span class="text-align-center"
      >მის: თბილისი, მ.კოსტავას ქ. #63; ტელ: (032) 2 15 86 86; ელ-ფოსტა:
      info@livo.ge</span
    >
  </div>
</div>

<!-- /Print participated auctions -->

<!-- /Results Modal -->

<!-- all results modal -->
<!--
<div *ngIf="isAllResultsModalOpen" class="custom-modal">
  <button class="custom-modal__bg" (click)="closeAllResultsModal()"></button>
  <div class="custom-modal__component custom-modal__component__all-results">
    <div class="modal-content">
      <div class="modal-header align-items-center px-4 py-3">
        <h5 class="modal-title f-color-dark f-size-14">ყველა შედეგის ნახვა</h5>
        <button type="button" class="close" (click)="closeAllResultsModal()">
          <img src="/assets/images/close.svg" alt="X" />
        </button>
      </div>
      <form [formGroup]="allResultsForm">
        <div class="d-flex justify-content-between align-items-center flex-wrap p-4">
          <button class="btn my-auctions__all-results-buttons mb-md-0 mb-3"
            [ngClass]="{ 'my-auctions__all-results-buttons__active': isModalStatusFilterOpen }"
            (click)="modalStatusesState()">
            სტატუსი
          </button>
          <button class="btn my-auctions__all-results-buttons"
            [ngClass]="{ 'my-auctions__all-results-buttons__active': isModalDateFilterOpen }"
            (click)="modalDateState()">
            თარიღი
          </button>
        </div>
        <div [hidden]="!isModalStatusFilterOpen" class="bg-light-shade-blue px-4">
          <div *ngFor="let status of getAuctionStatuses" class="my-auctions__filter-status-item py-3" unselectable="on">
            <label
              class="mb-0 f-color-actions-text d-flex align-items-center justify-content-between cursor-pointer user-select-none">{{ status.display_name }}
              <app-checkbox [checked]="allResultsForm.get('statuses').value.includes(status.key)"
                [control]="allResultsForm.get('statuses')" [elementValue]="status.key"></app-checkbox>
            </label>
          </div>
        </div>
        <div [hidden]="!isModalDateFilterOpen">
          <div class="d-flex align-items-center justify-content-between flex-wrap bg-light-shade-blue px-4 py-3">
            <div class="form-group mb-sm-0 mb-3 col-sm-6 col-12 px-0 pr-sm-3">
              <input appFormErrorMsg class="form-control auction-custom-input" formControlName="start_date"
                name="start_date" type="datetime-local" />
            </div>
            <div class="form-group mb-0 col-sm-6 col-12 px-0 pl-sm-3">
              <input appFormErrorMsg class="form-control auction-custom-input" formControlName="end_date"
                name="end_date" type="datetime-local" />
            </div>
          </div>
        </div>
        <div *ngIf="allResultsDataFailed" class="bg-light-shade-blue d-flex flex-column align-items-center px-4 py-5 text-center">
          <img src="/assets/images/not-found-paper.svg" alt="not found" class="mb-3" />
          <h5 class="f-color-actions-text f-size-18 mb-3 fw-bold">ამ მონაცემებით აუქციონი არ მოიძებნა</h5>
          <p class="f-color-actions-text f-size-14 mb-0">გაფილტრე სხვა სტატუსით და თარიღით</p>
        </div>
      </form>
      <div class="d-flex align-items-center justify-content-end border-top-none p-4">
        <button type="button" class="btn btn-light p-3 m-0 mr-3 f-size-14 fw-medium" data-dismiss="modal"
          (click)="closeAllResultsModal()">გაუქმება</button>
        <button type="button" class="btn btn-primary p-3 m-0 f-size-14 fw-medium" data-toggle="tooltip"
          data-placement="top" [title]="!allResultsForm.valid ? 'ყველა ველი სავალდებულოა' : ''"
          [disabled]="!allResultsForm.valid" (click)="allResultsForm.valid ? importAllResults() : ''">შედეგების
          ექსპორტი</button>
      </div>
    </div>
  </div>
</div> -->

<!-- /all results modal -->
